import {useTranslation} from "react-i18next";
import {Col} from "@pg-design/grid";
import {Text} from "@pg-design/text";

import {FLTRPricingBox} from "./FLTRPricingBox";
import {SubscriptionBox} from "./SubscriptionBox";

export const FLTRSubscriptionBox = () => {
    const {t} = useTranslation();
    return (
        <SubscriptionBox>
            <Col md={12}>
                <Text variant="headline_3" as="p" align="center">
                    {t("pricing.fltr_subscription.title")}
                </Text>
            </Col>

            <Col sm={4} md={12}>
                <FLTRPricingBox />
            </Col>
        </SubscriptionBox>
    );
};
